module.exports = __webpack_public_path__ + "media/sneaky_snitch.fdaf076d.mp3";